import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../store/actions";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    desc: "",
  });

  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile.profileDetails);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      number: "",
      desc: "",
    });
  };

  const handleSubmit = () => {
    const { name, number, desc } = formData;
    const title = `${name} - ${number}`;

    const date = new Date();
    const dateString = `${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()} - ${date.getHours()}:${date.getMinutes()}`;

    // TODO: Replace with GridSend email service integration
    let emailHTML = "";
    emailHTML += "<div>";
    emailHTML += '  <span style="font-size: 18px;">';
    emailHTML += "  Hello, <br/>";
    emailHTML +=
      "  There is a new report for you from the D'Butler platform. Take a look and review the information below.";
    emailHTML += "  </span><br/><br/>";
    emailHTML += '  <div style="displa: flex; flex-direction: column;">';
    emailHTML +=
      '    <span style="font-weight: bold;">Report type:</span> <span>Contact info</span><br/>';
    emailHTML +=
      '    <span style="font-weight: bold;">Time of report:</span> <span>' +
      dateString +
      "</span><br/>";
    emailHTML +=
      '    <span style="font-weight: bold;">User who sent the report:</span> <span>' +
      profile.name +
      " (email: " +
      profile.emailContact +
      " phone: " +
      profile.phoneContact +
      ")</span><br/>";
    emailHTML +=
      ' </div><br/><span style="font-weight: bold;">Platform:</span><span>Desktop</span><br/>';
    emailHTML +=
      '  <span style="font-weight: bold;">Report text:</span><br/><br/>';
    emailHTML += '  <span style="font-size: 18px;">' + desc + "</span>";
    emailHTML +=
      '<br /><br/><span style="font-size: 18px;">Your\'s truly, <br /> D\'Bot.</span>';
    emailHTML += "</div>";

    dispatch(actions.reportProblem(title, emailHTML, resetForm));
  };

  const { name, number, desc } = formData;

  return (
    <>
      <div className="contactInfo">
        <div className="contactInfoTitle">
          <span>Call us</span>
        </div>
        <span>Phone number:</span>
        <span>40094608</span>
      </div>
      <span className="supportContentTitle">Contact Us</span>
      <div className="supportContentBox">
        <div className="supportContactForm">
          <div className="supportFormTitle">
            <span>Email Customer service</span>
          </div>
          <div className="supportFormTopInputs">
            <div className="supportFormInput">
              <span>Your name:</span>
              <input
                type="text"
                name="name"
                value={name}
                onChange={handleChange}
              />
            </div>
            <div className="supportFormInput">
              <span>Your phone number:</span>
              <input
                type="text"
                name="number"
                value={number}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="supportFormBottomInput">
            <span>Subject:</span>
            <textarea
              name="desc"
              value={desc}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="supportFormButtonBox">
            <div className="supportFormButton" onClick={handleSubmit}>
              Submit
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
